<template>
  <div
    class="col-start-1w-full relative col-span-6 -m-2 grid grid-cols-2 justify-start gap-x-[calc(100%/13)] gap-y-8 overflow-hidden p-2 tablet:grid-cols-[repeat(auto-fill,minmax(210px,1fr))] tablet:gap-y-16 desktop:col-span-10 desktop:col-start-2"
    ref="productGrid"
  >
    <TransitionGroup name="list">
      <ProductCard
        v-for="product in props.products"
        :brand="props.brand"
        :product="product"
        :key="product.attributes?.slug"
        class="!min-h-fit"
      />
    </TransitionGroup>
  </div>
</template>
<script setup lang="ts">
import { ProductFragment } from "#gql";

const props = defineProps<{
  brand?: string | undefined | null;
  products: ProductFragment[] | [];
}>();

const productGrid = ref<HTMLElement | null>(null);

defineExpose({
  productGrid,
});
</script>
<style lang="scss" scoped>
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease-out;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
</style>
